import React from "react";

function Error() {
  return (
    <div>
      {" "}
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h1>404</h1>
        <p>الصفحة غير موجودة</p>
      </div>
    </div>
  );
}

export default Error;
